











import { Nullable } from "@gemma/typescript-types";
import { Icon } from "@timesheets/webapp-support";
import Vue, { PropOptions } from "vue";
import "./scss";

export default Vue.extend({
  name: "IconedInput",
  inheritAttrs: false,
  props: {
    defaultIcon: { type: Boolean, default: true } as PropOptions<boolean>,
    id: { type: String, default: "" } as PropOptions<string>,
    value: { type: String, default: "" } as PropOptions<string>,
    name: { type: String } as PropOptions<string>,
    placeholder: { type: String, default: "" } as PropOptions<string>,
    disabled: { type: Boolean } as PropOptions<boolean>,
    readonly: { type: Boolean } as PropOptions<boolean>,
    required: { type: Boolean } as PropOptions<boolean>,
    autofocus: { type: Boolean } as PropOptions<boolean>,
    icon: { type: Object, default: null } as PropOptions<Nullable<Icon>>,
    type: { type: String, default: "text" } as PropOptions<string>,
  },
  data() {
    return {
      name_: this.name || this.id,
      localValue: this.value,
    };
  },
  computed: {
    hasLeftSlot() {
      const hasLeftSlot = !!(this.$slots.left || [])[0];

      return hasLeftSlot;
    },
    hasRightSlot() {
      const hasRightSlot = this.defaultIcon || !!(this.$slots.right || [])[0];

      return hasRightSlot;
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.localValue = newValue;
      }
    },
  },
  methods: {
    update(event: { target: any }) {
      this.$emit("input", event.target.value);
    },
  },
});
